import { render, staticRenderFns } from "./cardLink.vue?vue&type=template&id=abddbd04&scoped=true&lang=pug&"
import script from "./cardLink.vue?vue&type=script&lang=js&"
export * from "./cardLink.vue?vue&type=script&lang=js&"
import style0 from "./cardLink.vue?vue&type=style&index=0&id=abddbd04&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abddbd04",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/corp-dev.1clicom.ru/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('abddbd04')) {
      api.createRecord('abddbd04', component.options)
    } else {
      api.reload('abddbd04', component.options)
    }
    module.hot.accept("./cardLink.vue?vue&type=template&id=abddbd04&scoped=true&lang=pug&", function () {
      api.rerender('abddbd04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/ui/cardLink.vue"
export default component.exports